// SQL Workplace 常數設定

// API base 路徑：所有端點都掛在根層 /api/v1/sql-workplace，沒有產品線段。
// 兩個名稱同值，呼叫端沿用原本的區分。
export const API_BASE_PRODUCT = '/api/v1/sql-workplace'
export const API_BASE = API_BASE_PRODUCT

// 後端 visibility 定義（1=Private/My、2=Public）
export const VISIBILITY_PRIVATE = 1
export const VISIBILITY_PUBLIC = 2

// 權限 key（對應後端 perm.BiSQLWorkplace）
export const PERM_USE = 'use bi sql workplace' // 進頁面 / 讀 info
export const PERM_PUBLIC_EDIT = 'edit bi sql workplace public queries' // 建立/編輯/刪除 public query
export const PERM_MODIFY_OWNER = 'modify bi sql workplace public queries owner' // 轉移 public query owner

// fetch 共用選項（Cookie-based session）
export const FETCH_OPTS = { credentials: 'include' }

// localStorage key 前綴 — 工作區狀態持久化（首次/回訪 landing 還原）
//   實際 key 為 `<前綴>:<帳號 code>`（見 store/workspace.js 的 storageKey()），依帳號隔離避免換帳號讀到前一人的
//   query tabs / SQL；不分產品線。此字串本身與 `<前綴>:<code>:<product>` 是舊版 key 形狀，
//   後者由 workspace.js 搬遷、sweep 清理（見 utils/storage-sweep.js）。
export const STORAGE_KEY_PREFIX = 'sql-workplace:v1'

// 版面預設比例（附件 1：左 15% / 編輯器 60% / 結果 40%）
export const DEFAULT_LEFT_WIDTH = 0.15 // 左面板佔總寬比例
export const DEFAULT_EDITOR_HEIGHT = 0.6 // 編輯器佔右側高度比例（結果 = 1 - 此值）

// 版面拖曳邊界（避免拖到太小）
export const MIN_LEFT_WIDTH = 0.1
export const MAX_LEFT_WIDTH = 0.4
export const MIN_EDITOR_HEIGHT = 0.2
export const MAX_EDITOR_HEIGHT = 0.85

// 分頁類型
export const TAB_SQL = 'sql' // SQL Query 分頁（可編輯）
export const TAB_PREVIEW = 'preview' // Table Preview 分頁（唯讀）

// 編輯器分頁上限與分頁名顯示上限（PRD FR-ED-001）
export const MAX_EDITOR_TABS = 15 // 達上限再開分頁要擋下並警告
export const TAB_NAME_MAX = 20 // 分頁名顯示上限（含空白），超過截斷加 …、hover 顯示完整

// 執行限制
export const EXEC_TIMEOUT_MS = 20 * 60 * 1000 // System Hard Stop：20 分鐘（PRD FR-ED-015 / VAL-006）

// 表格樣式（Results / Table Preview / History inline 共用，對齊 Figma）
//   表頭：白底、12px、一般體、灰字（! 蓋過 .onion-layout 全域 th）；資料列：14px 深字；cell padding 12px、列下框線
export const TABLE_HEAD_CLASS = 'text-left !bg-base-100 !font-normal !text-xs !text-base-content/80 px-3 py-3 border-b border-base-200 whitespace-nowrap'
export const TABLE_CELL_CLASS = 'text-[14px] text-base-content/90 px-3 py-3 border-b border-base-200 whitespace-nowrap'

// 結果格
export const PAGE_SIZE_OPTIONS = [20, 50, 100, 200]
export const DEFAULT_PAGE_SIZE = 50
export const FETCH_CACHE_PAGES = 4 // 一次抓並快取 4 頁
// 後端 /exec 每批固定 200 列（無 page_size 參數，見 utils/api.js）。前端用它判斷
//   「這份結果是不是補抓過不只一批」——超過一批就代表 rows 是多次獨立查詢拼接而成。
export const EXEC_BATCH_ROWS = 200
export const EXPORT_CSV_ROW_LIMIT = 100000 // 超過則截斷並警告
export const MAX_RESULT_TABS = 15 // Pin Result 釘選分頁上限（PRD FR-RP-011）

// 文字截斷
export const TOOLTIP_SQL_MAX = 120 // hover query 顯示 SQL 上限
export const HISTORY_SQL_PREVIEW_MAX = 72 // history 列 SQL 預覽上限

// Query History 上限（FIFO）
export const HISTORY_MAX = 200
export const HISTORY_INLINE_ROWS = 10 // inline 重跑顯示前 N 列

// 圖表類型（Explore Modal）：折線 / 面積 / 長條 / 圓餅
//   Stacked Bar 不再是獨立選項；改為 bar 選了 Drilldown 時自動套堆疊規則（見 ExploreModal）
export const CHART_TYPES = ['line', 'area', 'bar', 'pie']

// Query 命名規則：英文字母 / 數字 / 空白 / 底線（維持嚴格、不放寬中文）
export const QUERY_NAME_PATTERN = /^[A-Za-z0-9_ ]+$/

// 資料夾（tag）命名規則：放寬允許中文（\p{L} 涵蓋各語言文字含中文、\p{N} 涵蓋數字）/ 空白 / 底線
//   供 My/Public 資料夾 rename 與 Save/Edit Modal 的 Tags 輸入共用；query name 仍用上面的 QUERY_NAME_PATTERN
export const TAG_NAME_PATTERN = /^[\p{L}\p{N}_ ]+$/u

// 未命名查詢預設名（Save Query Modal）
export const DEFAULT_QUERY_NAME = 'untitled_query'

// 無 tag query 的歸屬資料夾
export const UNTAGGED_FOLDER = 'Untagged'

// 工作區別（saved query 歸屬）
export const WS_MY = 'my'
export const WS_PUBLIC = 'public'
